module.exports = __webpack_public_path__ + "img/message.f3ee3540.svg";